// import { s8, createDiv, rectangle } from '@topology/core'
import {s8, createDiv} from '@topology/core'
import Vue from 'vue'
import UniScrollList from '@/components/uniWidgets/uniScrollList'
export function ScrollList(ctx, node) {
  // 绘制一个底图，类似于占位符
  // rectangle(ctx, node)
  if (!node.data) {
    return
  }
  if (typeof node.data === 'string') { // 解析data属性
    node.data = JSON.parse(node.data)
  }
  if (!node.data.data || !node.data.option || !node.data.option.columns) { // data/option/columns不允许为空
    return
  }
  if (node.elementId === undefined || node.elementId === null) {
    node.elementId = s8()
  }
  if (!node.elementLoaded) { // 初始化过程中首次调用
    // 创建一个div层
    let nodeDiv = createDiv(node)
    node.extDiv = nodeDiv
    document.body.appendChild(nodeDiv)
    node.addToDiv() // 添加当前节点到div层

    let classOption = node.data.option.classOption
    if (!classOption) {
      classOption = {
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 5, // 开始无缝滚动的数据量
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 21, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
    var ScrollListVueObject = Vue.extend(UniScrollList)
    let scrollList = new ScrollListVueObject({ // 创建无缝滚动
      propsData: {
        data: node.data.data,
        columns: node.data.option.columns,
        classOption: classOption
      }
    }).$mount()

    if (node.elementId) {
      scrollList.$el.id = 'uniScrollList' + node.elementId
    }
    scrollList.$el.style.width = '100%'
    scrollList.$el.style.height = '100%'
    node.extScrollList = scrollList
    nodeDiv.appendChild(scrollList.$el)

    node.extOnDestroy = doNodeDestroy // 关联处理节点销毁函数
    node.elementLoaded = true

    node.elementRendered = false
    // 等待父div先渲染完成调整尺寸
    setTimeout(function () {
      node.extDiv.style.x = node.rect.x + 'px'
      node.extDiv.style.y = node.rect.y + 'px'
      node.extDiv.style.width = node.rect.width + 'px'
      node.extDiv.style.height = node.rect.height + 'px'
    })
  } else {
  }

  if (!node.elementRendered) { // 节点重绘(会反复调用）
    // 初始化时，等待父div先渲染完成，避免初始图表控件太大。
    setTimeout(function () {
      console.log('node x:' + node.rect.x + ',div x:' + node.extDiv.style.x)
      node.extDiv.style.x = node.rect.x + 'px'
      node.extDiv.style.y = node.rect.y + 'px'
      node.extDiv.style.width = node.rect.width + 'px'
      node.extDiv.style.height = node.rect.height + 'px'

      node.extScrollList.data = node.data.data
      node.extScrollList.columns = node.data.option.columns
      if (node.data.option.classOption) {
        node.extScrollList.classOption = node.data.option.classOption
      }
      node.elementRendered = true
      // setTimeout(function () {
      //     var img = new Image()
      //     img.src = flvPlayerObjs[node.id].player.getDataURL({
      //         pixelRatio: 2
      //     })
      //     node.img = img
      // }, 100)
    })
  } else {
  }
}

// 处理节点销毁事件
function doNodeDestroy(node) {
  if (node.extScrollList) {
    node.extScrollList.$el.remove()
    node.extScrollList.$destroy()
    node.extScrollList = null
    // if (node.extDiv) {
    //   let seamlessScrollElement = document.getElementById('uniScrollList' + node.elementId)
    //   if (seamlessScrollElement) {
    //     node.extDiv.removeChild(seamlessScrollElement)
    //   }
    // }
  }
}

// # sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./src/components/topologyDiagram/scrollList/scrollList/index.js